export default "__VITE_ASSET__BHTDtBWG__"